import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import { jsx, css, ThemeProvider } from 'theme-ui';
import { MDXProvider } from '@mdx-js/react';
import React from 'react';
import { Global } from '@emotion/core';
import merge from 'deepmerge';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var Overlay = function Overlay(_ref) {
  var onClick = _ref.onClick;
  return jsx(React.Fragment, null, jsx("div", {
    onClick: onClick,
    sx: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }), jsx(Global, {
    styles: css({
      body: {
        overflow: ['hidden', 'auto']
      }
    })
  }));
};

var Sidenav = React.forwardRef(function (_ref2, ref) {
  var open = _ref2.open,
      _ref2$styles = _ref2.styles,
      styles = _ref2$styles === void 0 ? {} : _ref2$styles,
      components = _ref2.components,
      props = _objectWithoutProperties(_ref2, ["open", "styles", "components"]);

  return jsx(ThemeProvider, {
    theme: {
      styles: merge({
        ul: {
          listStyle: 'none',
          p: 0,
          m: 0,
          ul: {
            a: {
              pl: 4
            }
          }
        },
        a: {
          display: 'block',
          px: 2,
          py: 2,
          color: 'inherit',
          textDecoration: 'none',
          fontSize: 1,
          fontWeight: 'bold'
        }
      }, styles)
    }
  }, open && jsx(Overlay, props), jsx(MDXProvider, {
    components: components
  }, jsx("div", _extends({}, props, {
    ref: ref,
    sx: {
      position: ['fixed', 'sticky'],
      top: 0,
      left: 0,
      bottom: [0, 'auto'],
      zIndex: 1,
      minWidth: 0,
      width: 256,
      maxHeight: '100vh',
      overflowX: 'visible',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      transition: 'transform .2s ease-out',
      transform: [open ? 'translateX(0)' : 'translate(-100%)', 'none'],
      bg: ['background', 'transparent']
    }
  }))));
});

var flattenLinks = function flattenLinks(children) {
  return React.Children.toArray(children).reduce(function (acc, child) {
    if (child.props && child.props.mdxType === 'a') {
      return [].concat(_toConsumableArray(acc), [child]);
    }

    if (!child.props || !child.props.children) {
      return acc;
    }

    return React.Children.toArray([].concat(_toConsumableArray(acc), _toConsumableArray(flattenLinks(child.props.children))));
  }, []);
};

var removeSlash = function removeSlash(str) {
  return str.length > 1 ? str.replace(/\/$/, '') : str;
};

var PaginationLink = function PaginationLink(_ref3) {
  var label = _ref3.label,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["label", "children", "mdxType", "originalType", "parentName"]);

  return jsx("a", _extends({}, props, {
    sx: {
      fontSize: 1,
      color: 'inherit',
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  }), jsx("div", null, label), jsx("div", {
    sx: {
      fontSize: 3
    }
  }, children));
};

var Pagination = function Pagination(_ref4) {
  var _ref4$pathname = _ref4.pathname,
      pathname = _ref4$pathname === void 0 ? '' : _ref4$pathname,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["pathname", "children"]);

  var links = flattenLinks(children);
  var index = links.findIndex(function (link) {
    return link.props.href === removeSlash(pathname);
  });
  var hasPagination = index > -1;
  var previous = links[index - 1];
  var next = links[index + 1];
  return jsx("div", _extends({}, props, {
    sx: {
      display: 'flex'
    }
  }), hasPagination && previous && jsx(PaginationLink, _extends({}, previous.props, {
    label: "Previous:"
  })), jsx("div", {
    sx: {
      mx: 'auto'
    }
  }), hasPagination && next && jsx(PaginationLink, _extends({}, next.props, {
    label: "Next:"
  })));
};

export { Sidenav, Pagination };